import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from 'axios';
//components
import { LoginRedirectDialogBox } from '../helpers/LoginRedirectDialogBox';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import HomePage from './HomePage';
import SearchResultPage from './SearchResultPage/SearchResultPage';
import TimelineView from './timelineView';
import WpsPaylens from '../helpers/WpsPaylens';

export function MainContainer() {
    const [showLogin, setShowLogin] = useState(false);

    axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
        if (err.response.status === 401 || err.response.data.message === "401 Unauthorised") {
            setShowLogin(true);
        }
        return Promise.reject(err);
    })

    useEffect(() => {
        if (showLogin) {
            var modal1 = document.getElementById("loginModal");
            modal1.style.display = "block";
        }
    }, [showLogin])

    return (
        <>
            {showLogin ? <LoginRedirectDialogBox /> :
                <>
                    <Header />
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path='/result' element={<SearchResultPage />} />
                            <Route path='/timeline-view' element={<TimelineView />} />
                            <Route path="*" element={<Navigate to='/' replace />} />
                        </Routes>
                    </BrowserRouter>
                    <Footer />
                    <WpsPaylens />
                </>
            }
        </>
    );
}